import React, { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from '@Sage/hoi-poi-ui';
import Header from 'containers/components/layouts/Header';
import HeaderTitle from 'containers/components/layouts/HeaderTitle';
import HeaderSection from 'containers/components/layouts/HeaderSection';
import HeaderSectionDefault from 'containers/components/layouts/HeaderSectionDefault';
import ViewType from 'containers/components/ViewType';
import { getLiteral } from 'utils/getLiteral';
import colors from 'constants/colors';

const TAB_CONFIG = [
    {
        id: 'activity',
        path: '/campaigns/activity',
        titleKey: 'label_sales_campaigns',
        iconName: 'activities',
    },
    {
        id: 'marketing',
        path: '/campaigns/marketing',
        titleKey: 'label_email_campaigns',
        iconName: 'emailSendOutline',
    },
];

const CampaignsHeader = React.memo(() => {
    const hasEmailCampaigns = useSelector((state) => state.config.flagsmith?.spamchimp ?? false);
    const location = useLocation();
    const navigate = useNavigate();

    // Determine active section based on current path
    const activeSection = useMemo(() => {
        const pathname = location.pathname;
        if (pathname.startsWith('/campaigns/marketing')) {
            return 1;
        }
        // Default to activity (0) for /campaigns and /campaigns/activity
        return 0;
    }, [location.pathname]);

    // Handle tab change by navigating to the appropriate route
    const handleTabChange = useCallback(
        (event, index) => {
            const targetPath = TAB_CONFIG[index]?.path;
            if (targetPath && location.pathname !== targetPath) {
                navigate(targetPath);
            }
        },
        [navigate, location.pathname],
    );

    const tabs = useMemo(() => {
        if (!hasEmailCampaigns) return [];

        const activeColor = colors.actionMinor[500];
        const inactiveColor = colors.actionMinor[200];

        return TAB_CONFIG.map((config, index) => {
            const color = activeSection === index ? activeColor : inactiveColor;
            return {
                title: getLiteral(config.titleKey),
                icon: <Icon name={config.iconName} color={color} />,
            };
        });
    }, [activeSection, hasEmailCampaigns]);

    return (
        <Header>
            <HeaderSection>
                <HeaderTitle title={TAB_CONFIG[activeSection]?.titleKey} />
            </HeaderSection>
            {hasEmailCampaigns && (
                <ViewType onChange={handleTabChange} section={activeSection} tabs={tabs} />
            )}
            <HeaderSectionDefault />
        </Header>
    );
});

export default CampaignsHeader;
